import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";
import { IBranch } from "src/app/interfaces/branch";
import { CommonHttpOption } from "../../base/common-http-option";
import { IBranchAccount } from "src/app/interfaces/branch-account";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class BranchService {
  constructor(private core: CoreService) { }

  list(JustActiveBranch: boolean = true, page = 0, pageSize = 0): Observable<any> {
    return this.core.get(

      ServiceRoute.branch.list + JustActiveBranch,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getAghBranchInCompany(): Observable<any> {
    return this.core.get(
      ServiceRoute.branch.getAghBranchInCompany,
      new CommonHttpOption().headers,
      new CommonHttpOption().params
    );
  }

  getById(id: string): Observable<any> {
    return this.core.get(
      ServiceRoute.branch.getById + id,
      new CommonHttpOption().headers,
      new CommonHttpOption().params
    );
  }

  add(data: IBranch): Observable<any> {
    return this.core.post(
      ServiceRoute.branch.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: IBranch): Observable<any> {
    return this.core.put(
      ServiceRoute.branch.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.branch.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  changeStatus(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.branch.changeStatus,
      data,
      new CommonHttpOption().headers
    );
  }
  addAccount(data: IBranchAccount): Observable<any> {
    return this.core.post(
      ServiceRoute.branch.addAccount,
      data,
      new CommonHttpOption().headers
    );
  }

  listAccount(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.branch.listAccount + id,
      new CommonHttpOption().headers,
      new CommonHttpOption().params
    );
  }

  listByLogin(page = 0, pageSize = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.branch.listByLogin,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  listByCompanyHeader(page = 0, pageSize = 0, header: HttpHeaders): Observable<any> {
    return this.core.get(
      ServiceRoute.branch.listByLogin,
      header,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  listByHoldingId(params: any, page = 0, pageSize = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.branch.listByHoldingId,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
        .append('HoldingEncryptId', params && params.holdingEncryptId ? params.holdingEncryptId : '')
    );
  }

  listByHoldingIdAndCurrentSTU(params: any, page = 0, pageSize = 0): Observable<any> {
    debugger;
    return this.core.get(
      ServiceRoute.branch.listByHoldingIdAndCurrentSTU,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
        .append('HoldingEncryptId', params && params.HoldingEncryptId ? params.HoldingEncryptId : '')
        .append('BranchEncryptId', params && params.BranchEncryptId ? params.BranchEncryptId : '')
        .append('Name', params && params.Name ? params.Name : '')
        .append('ProvinceId', params && params.ProvinceId ? params.ProvinceId : '')
        .append('Sexuality', params && params.Sexuality ? params.Sexuality : '')
        .append('CityId', params && params.CityId ? params.CityId : '')
        .append('AreaId', params && params.AreaId ? params.AreaId : '')
    );
  }


  getpresenceBranchByProvinceId(provinceId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.branch.getpresenceBranchByProvinceId + provinceId,
      new CommonHttpOption().headers
    );
  }

  getBranchFroPrivateCourseRequest(provinceId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.branch.getBranchFroPrivateCourseRequest + provinceId,
      new CommonHttpOption().headers
    );
  }

  HoldingBranchsList(): Observable<any> {
    return this.core.get(
      ServiceRoute.branch.holdingBranchsList,
      new CommonHttpOption().headers
    );
  }
}
